import React from 'react'
import FiltersUI from './FiltersUI'

function GetMoviedataReturn(props) {
  const { movieFilterBy } = props
  function resethandle() {
    props.resethandleData()
    props.handleResetData()
    props.setcheckPopularMovie('')
    // props.setsortBy('popularity')
    props.setSelectedCastData([])
    props.setselectedCrewCenimato([])
    props.setselectedCrewProd([])
    props.setSelectedCrewDirector([])
    props.setselectedCrewEditor([])
    props.setSelectedCrewDialog([])
    props.setselectedCrewMusic([])
    props.setSearchPersonCast('')
    props.setSearchPersonProd('')
    props.setSearchPersonEditor('')
    props.setSearchPersonCenimato('')
    props.setSearchPersonMusic('')
    props.setSearchPersonDialog('')
    props.setSearchPerson('')
    props.setagevalue('')
  }

  const changeSortOrderBy = e => {
    props.setFromvalue(10)
    props.setSearchListTrue(false)
    props.setsortOrderBy(e.target.value)
  }

  const ageRestrictionClear = () => {
    props.setagevalue('')
    delete movieFilterBy.ageRestriction
  }

  const changeSortByValue = e => {
    props.setFromvalue(10)
    props.setSearchListTrue(false)
    props.setsortBy(e.target.value)
  }

  const changeOthers = selectedOption => {
    props.setSearchListTrue(false)
    props.setselectedOthers(selectedOption)
  }

  const sortPopularMoviesReset = () => {
    delete movieFilterBy.popularMovie
    props.setcheckPopularMovie('')
  }

  const sortGOATReset = () => delete movieFilterBy.GOAT

  const sortoriginalLanguage = () => delete movieFilterBy.originalLanguageTelugu

  return (
    <FiltersUI
      sortPopularMoviesReset={sortPopularMoviesReset}
      handlePepularMovie={props.handlePepularMovie}
      handleGOAT={props.handleGOAT}
      handleoriginalLanguage={props.handleoriginalLanguage}
      sortGOATReset={sortGOATReset}
      sortoriginalLanguage={sortoriginalLanguage}
      GOAT={props.GOAT}
      originalLanguageTelugu={props.originalLanguageTelugu}
      checkPopularMovie={props.checkPopularMovie}
      selectedCrewCenimato={props.selectedCrewCenimato}
      setselectedCrewCenimato={props.setselectedCrewCenimato}
      setselectedCrewProd={props.setselectedCrewProd}
      setSelectedCrewDirector={props.setSelectedCrewDirector}
      setselectedCrewEditor={props.setselectedCrewEditor}
      setSelectedCrewDialog={props.setSelectedCrewDialog}
      setselectedCrewMusic={props.setselectedCrewMusic}
      selectedCrewProd={props.selectedCrewProd}
      selectedCrewDirector={props.selectedCrewDirector}
      selectedCrewEditor={props.selectedCrewEditor}
      selectedCrewDialog={props.selectedCrewDialog}
      selectedCrewMusic={props.selectedCrewMusic}
      // conditionBasedFilterCastORCrew={props.conditionBasedFilterCastORCrew}
      selectedCastData={props.selectedCastData}
      setSelectedCastData={props.setSelectedCastData}
      sortBy={props.sortBy}
      sortByReset={props.sortByReset}
      isExpandAll={props.isExpandAll}
      setExpandAll={props.setExpandAll}
      SearchPersonCast={props.SearchPersonCast}
      setSearchPersonCast={props.setSearchPersonCast}
      setSearchPersonProd={props.setSearchPersonProd}
      SearchPersonProd={props.SearchPersonProd}
      setSearchPersonEditor={props.setSearchPersonEditor}
      SearchPersonEditor={props.SearchPersonEditor}
      setSearchPersonCenimato={props.setSearchPersonCenimato}
      SearchPersonCenimato={props.SearchPersonCenimato}
      setSearchPersonMusic={props.setSearchPersonMusic}
      SearchPersonMusic={props.SearchPersonMusic}
      setSearchPersonDialog={props.setSearchPersonDialog}
      SearchPersonDialog={props.SearchPersonDialog}
      SearchPerson={props.SearchPerson}
      setSearchPerson={props.setSearchPerson}
      ResetAccordianData={props.ResetAccordianData}
      PersonCrewFilterData={props.PersonCrewFilterData}
      crewNameSearch={props.crewNameSearch}
      ToRatingvalue={props.ToRatingvalue}
      changeCategoryRatingTo={props.changeCategoryRatingTo}
      // fromRatingValue={props.fromRatingValue}
      disapperAllFilters={props.disapperAllFilters}
      searchValue={props.searchValue}
      sortOrderReset={props.sortOrderReset}
      setagevalue={props.setagevalue}
      showDates={props.showDates}
      showDatePicker={props.showDatePicker}
      setfilterDisableWithoutSelect={props.setfilterDisableWithoutSelect}
      filterDisableWithoutSelect={props.filterDisableWithoutSelect}
      statusType={props.statusType}
      isLoading={props.isLoading}
      checkTrue={props.checkTrue}
      selectedGenres={props.selectedGenres}
      changeCategoryAge={props.changeCategoryAge}
      agevalue={props.agevalue}
      changeCategoryGenre={props.changeCategoryGenre}
      selectedOTT={props.selectedOTT}
      changeCategoryOTT={props.changeCategoryOTT}
      Ratingvalue={props.Ratingvalue}
      changeCategoryRating={props.changeCategoryRating}
      changeOthers={changeOthers}
      selectedOthers={props.selectedOthers}
      checkposterlink={props.checkposterlink}
      checkPosterurl={props.checkPosterurl}
      changeAbout={props.changeAbout}
      selectedAbout={props.selectedAbout}
      // AboutEnTe={props.AboutEnTe}
      statemovieDirectedBy={props.statemovieDirectedBy}
      movieDirectedBy={props.movieDirectedBy}
      checkmovieProducedBy={props.checkmovieProducedBy}
      checkproducer={props.checkproducer}
      changeSortByValue={changeSortByValue}
      changeSortOrderBy={changeSortOrderBy}
      sortByorder={props.sortByorder}
      CheckBoxClick={props.CheckBoxClick}
      resethandle={resethandle}
      getMoviesFilterData={props.getMoviesFilterData}
      ageRestrictionClear={ageRestrictionClear}
      PersonCrewFilter={props.PersonCrewFilter}
      handleFilterChange={props.handleFilterChange}
      movieFilterBy={movieFilterBy}
    />
  )
}

export default GetMoviedataReturn
